import React, { useCallback, useEffect, useState } from "react";
import AdminNavigation from "../AdminNavigation";
import { validateField } from "../../../pages/functions";
import { addNotification as notify } from "reapop";
import Select from "../../../forms/Select";
import { COUNTRIES } from "../../../constants";
import connect from "react-redux/es/connect/connect";
import { api_v2 } from "../../NewIndex.api";
import "./style.css";
import TreeNodeDraft from "./TreeNodeDraft";
import TreeNodeLive from "./TreeNodeLive";
import AdminConfirmationModal from "../adminConfirmationModal";
import EditModal from "./EditModal";
import CopyModal from "./CopyModal";
import MessageModal from "./MessageModal";

const ami = (props) => {
  const amiFields = {
    country: {
      name: "Country",
      value: "",
      rules: { title: "Country", required: true },
    },
    userType: {
      name: "User Type",
      value: "",
      rules: { title: "User Type", required: true },
    },
    language: {
      name: "Language",
      value: "",
      rules: { title: "Language", required: true },
    },
  };
  const [fields, setFields] = useState(amiFields);
  const userTypeOptions = [
    { value: "HCP", label: "HCP" },
    { value: "ABBVIE_EMPLOYEE", label: "Employee" },
    { value: "Patient", label: "Patient" },
  ];

  const [languageOptions, setLanguageOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [activeTab, setActiveTab] = useState("liveAMI");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editNodeId, setEditNodeId] = useState(null);
  const [editText, setEditText] = useState("");
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [messageNodeId, setMessageNodeId] = useState(null);

  const [showAdminConfirmationModal, setShowAdminConfirmationModal] =
    useState(false);
  const [showData, setShowData] = useState(false);

  const [draftIsAvailable, setDraftIsAvailable] = useState(false);
  const [copyEnabled, setCopyEnabled] = useState(false);
  const [deleteDraft, setDeleteDraft] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);

    // Segregate data
  const [treeLive, setTreeLive] = useState([]);
  const [treeDraft, setTreeDraft] = useState([]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const showNotification = (title, message, status) => {
    props.notify({
      title,
      message,
      status,
      position: "tr",
      dismissible: true,
      dismissAfter: 3000,
    });
  };

  const validate = useCallback(
    (e, field) => {
      const inputValue = e.target.value.toLowerCase();
      const emojiRegex =
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF\uD83D\uDE00-\uDE4F])/g;
      const scriptRegex =
        /<script>|<iframe>|<embed>|<object>|<link>|<img>|<svg>|<textarea>|<meta>|<form>|\bscript\b|\bonerror\b|\bonload\b|\bonclick\b|\bonmouseover\b|\bsrc\b|\bhref\b|%3cscript%3e|%3ciframe%3e|%3cembed%3e|%3cobject%3e|%3clink%3e|%3cimg%3e|%3csvg%3e|%3ctextarea%3e|%3cmeta%3e|%3cform%3e/g;

      if (emojiRegex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        showNotification(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (scriptRegex.test(inputValue)) {
        // HTML Tags and Script detected, prevent it from being added
        showNotification(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      }
      const validateFields = validateField(e, field, fields);
      setFields({ ...validateFields });
    },
    [fields]
  );

  const getLanguageList = useCallback(() => {
    const languageOptions = [];
    api_v2.fetchTETLanguage((JsonKeys) => {
      JsonKeys.forEach((languageList) => {
        languageOptions.push({
          value: languageList.code,
          label: languageList.language,
        });
      });
      setLanguageOptions(languageOptions);
    });
  }, []);

  const getCountriesList = useCallback(() => {
    const countryList = props.referenceData.filter(
      (item) => item.type === COUNTRIES
    )[0].countries;
    const countryOptions = countryList.map((item) => ({
      value: item.name,
      label: item.name,
    }));
    setCountryOptions(countryOptions);
  }, []);

  useEffect(() => {
    resetState();
    if (countryOptions.length === 0) {
      getCountriesList();
    }
    if (languageOptions.length === 0) {
      getLanguageList();
    }
  }, []);

  const resetState = () => {
    let fieldsValue = fields;
    fieldsValue.country.value = "";
    fieldsValue.userType.value = "";
    fieldsValue.language.value = "";
    setFields({ ...fieldsValue });
    setShowAdminConfirmationModal(false);
    setShowData(false);
    setTreeDraft([]);
    setTreeLive([]);
    setDraftIsAvailable(false);
    setCopyEnabled(false);
    setNodeCounter(0);
  };

  const onToggleLive = (nodeId) => {
    const toggleRecursive = (nodes) => {
      return nodes.map((node) => {
        if (node.id === nodeId) {
          return { ...node, expanded: !node.expanded };
        } else if (node.children && node.children.length > 0) {
          return { ...node, children: toggleRecursive(node.children) };
        } else {
          return node;
        }
      });
    };
    setTreeLive((prevTree) => toggleRecursive(prevTree));
  };

  const onToggleDraft = (nodeId) => {
    const toggleRecursive = (nodes) => {
      return nodes.map((node) => {
        if (node.id === nodeId) {
          return { ...node, expanded: !node.expanded };
        } else if (node.children && node.children.length > 0) {
          return { ...node, children: toggleRecursive(node.children) };
        } else {
          return node;
        }
      });
    };
    setTreeDraft((prevTree) => toggleRecursive(prevTree));
  };

  const getMaxNodeId = (nodes) => {
    let max = 0;
    const traverse = nlist => {
      nlist.forEach(node => {
        if (node.id && node.id.startsWith('node-')) {
          const num = parseInt(node.id.slice(5));
          if (!isNaN(num)) max = Math.max(max, num);
        }
        if (node.children && node.children.length > 0) traverse(node.children);
      });
    };
    traverse(nodes);
    return max;
  };

  //delete components
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteNodeId, setDeleteNodeId] = useState(null);

  //add node
  const [nodeCounter, setNodeCounter] = useState(() => getMaxNodeId([]));

  //delete functions
  const confirmDelete = (deleteNodeId) => {
    setTreeDraft((prevTree) => removeNodeFromTree(deleteNodeId, prevTree));
    setOpenDeleteModal(false);
    setDeleteNodeId(null);
  };

  const removeNodeFromTree = (nodeId, nodes) => {
    return nodes
      .map((node) => {
        if (node.id === nodeId) return null;
        if (node.children && node.children.length > 0) {
          const newChildren = removeNodeFromTree(nodeId, node.children);
          return { ...node, children: newChildren };
        }
        return node;
      })
      .filter(Boolean); // Removes all nulls
  };

  //add node functions
  const addChildNode = (parentId) => {
    const recursiveAdd = (nodes) => {
      return nodes.map((node) => {
        if (node.id === parentId) {
          const newId = `node-${nodeCounter + 1}`;
          const newNode = {
            id: newId,
            htmlContent: "<p>New Node</p><p>Click edit to add content...</p>",
            expanded: false,
            children: [],
          };
          setNodeCounter((prev) => prev + 1);
          return {
            ...node,
            expanded: true,
            children: [...node.children, newNode],
          };
        } else if (node.children && node.children.length > 0) {
          return {
            ...node,
            children: recursiveAdd(node.children),
          };
        } else {
          return node;
        }
      });
    };
    setTreeDraft((oldTree) => recursiveAdd(oldTree));
  };

  const onEditNode = (nodeId, newText) => {
    const editRecursive = (nodes) => {
      return nodes.map((node) => {
        if (node.id === nodeId) {
          return { ...node, htmlContent: newText };
        } else if (node.children && node.children.length > 0) {
          return { ...node, children: editRecursive(node.children) };
        } else {
          return node;
        }
      });
    };
    setTreeDraft((oldTree) => editRecursive(oldTree));
  };

  const onSetMessages = (nodeId, messages) => {
    const updateRecursive = (nodes) => {
      return nodes.map((node) => {
        if (node.id === nodeId) {
          return { ...node, messages: messages };
        } else if (node.children && node.children.length > 0) {
          return { ...node, children: updateRecursive(node.children) };
        } else {
          return node;
        }
      });
    };
    setTreeDraft((oldTree) => updateRecursive(oldTree));
  };

  const getNodeMessages = (nodeId) => {
    const findRecursive = (nodes) => {
      for (const node of nodes) {
        if (node.id === nodeId) {
          return node.messages || null;
        }
        if (node.children && node.children.length > 0) {
          const found = findRecursive(node.children);
          if (found !== null) return found;
        }
      }
      return null;
    };
    return findRecursive(treeDraft);
  };

  const getNodeTitle = (nodeId) => {
    const findRecursive = (nodes) => {
      for (const node of nodes) {
        if (node.id === nodeId) {
          return node.htmlContent || "";
        }
        if (node.children && node.children.length > 0) {
          const found = findRecursive(node.children);
          if (found) return found;
        }
      }
      return null;
    };
    return findRecursive(treeDraft);
  };

  const handleSearchData = useCallback(() => {
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
    };
    api_v2.fetchAmiData(payload, (res) => {
      if (res.live === null && res.draft === null) {
        setTreeDraft([]);
        setTreeLive([]);
        setShowAdminConfirmationModal(true);
        setActiveTab("draftAMI");
        setDraftIsAvailable(false);
        setCopyEnabled(false);
      } else if (res.live !== null && res.draft === null) {
        let jsonObject = JSON.parse(res.live.jsonNode);
        setActiveTab("liveAMI");
        setShowData(true);
        setTreeDraft([]);
        setTreeLive(jsonObject.hierarchical);
        setDraftIsAvailable(false);
        setCopyEnabled(false);
      } else if (res.live === null && res.draft !== null) {
        if (res.draft.jsonNode) {
          let jsonObject = JSON.parse(res.draft.jsonNode);
          setActiveTab("draftAMI");
          setShowData(true);
          setTreeDraft(jsonObject.hierarchical);
          setTreeLive([]);
        } else {
          setActiveTab("draftAMI");
          setShowData(true);
          setTreeDraft(() => [
            {
              id: "project-1",
              htmlContent:
                "<p>New Node</p><p>Click edit to add content...</p>",
              expanded: false,
              children: [],
            },
          ]);
          setTreeLive([]);
        }
        setDraftIsAvailable(true);
        setCopyEnabled(false);
      } else if (res.live !== null && res.draft !== null) {
        let jsonObjectLive = JSON.parse(res.live.jsonNode);
        let jsonObjectDraft = JSON.parse(res.draft.jsonNode);
        setActiveTab("draftAMI");
        setShowData(true);
        setTreeDraft(jsonObjectDraft.hierarchical);
        setTreeLive(jsonObjectLive.hierarchical);
        setDraftIsAvailable(true);
        setCopyEnabled(false);
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, [fields]);

  const creatNewDraft = useCallback(() => {
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
    };
    api_v2.createNewAmiDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "Created Successfully", "success");
        setShowAdminConfirmationModal(false);
        handleSearchData();
      } else if (res.status === 417) {
        showNotification("Error", "Data already exists!!", "error");
        setShowAdminConfirmationModal(false);
        resetState();
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
        setShowAdminConfirmationModal(false);
        resetState();
      }
    });
  }, [fields]);

  const handleCreateDraft = useCallback(() => {
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
    };
    api_v2.createAmiDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "Draft Created Successfully", "success");
        handleSearchData();
      } else if (res.status === 417) {
        showNotification("Error", "Draft already exists!!", "error");
        resetState();
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
        resetState();
      }
    }),
      () =>
        showNotification(
          "ERROR!",
          "Something went wrong, please try again after sometime..",
          "error"
        );
  }, [fields]);

  const handleDeleteDraft = useCallback(() => {
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
    };
    api_v2.deleteAmiDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        setTreeDraft([]);
        setDeleteDraft(false);
        showNotification("Success", "Draft Deleted Successfully", "success");
        if ((treeLive || []).length > 0) {
          setShowData(true);
          setActiveTab("liveAMI");
          setDraftIsAvailable(false);
        } else {
          resetState();
        }
      } else {
        setDeleteDraft(false);
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
        resetState();
      }
    }),
      () => {
        setDeleteDraft(false);
        showNotification(
          "ERROR!",
          "Something went wrong, please try again after sometime..",
          "error"
        );
      };
  }, [fields, treeLive, treeDraft]);

  const handlePublishDraft = useCallback(() => {
    let jsonObject = {
      hierarchical: treeDraft,
    };
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      jsonNode: JSON.stringify(jsonObject),
    };
    api_v2.publishAmiDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        setOpenPublishModal(false);
        showNotification("Success", "Draft Published Successfully", "success");
        handleSearchData();
      } else {
        setOpenPublishModal(false);
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
        resetState();
      }
    });
  }, [fields, treeDraft]);

  const handleSave = useCallback(() => {
    let jsonObject = {
      hierarchical: treeDraft,
    };
    const payload = {
      country: fields.country.value,
      userType: fields.userType.value,
      language: fields.language.value,
      jsonNode: JSON.stringify(jsonObject),
    };
    api_v2.saveAmiDraft(payload, (res) => {
      if (res.ok && res.status === 200) {
        showNotification("Success", "Draft Saved Successfully", "success");
      } else {
        showNotification(
          "Error",
          "Something went wrong, Please try again later",
          "error"
        );
      }
    });
  }, [fields, treeDraft]);

  useEffect(() => {
    setNodeCounter(getMaxNodeId(treeDraft));
  }, [treeDraft]);

  return (
    <div>
      <div className="v2_container">
        <div className="row">
          {openDeleteModal && (
            <AdminConfirmationModal
              isModalOpen={openDeleteModal}
              toggleYes={() => confirmDelete(deleteNodeId)}
              toggleCancel={() => setOpenDeleteModal(false)}
              bodyContent={"Are you sure you want to delete?"}
            />
          )}
          {showAdminConfirmationModal && (
            <AdminConfirmationModal
              isModalOpen={showAdminConfirmationModal}
              toggleYes={creatNewDraft}
              toggleCancel={() => {
                setShowAdminConfirmationModal(false);
                resetState();
              }}
              bodyContent={
                "This data does not exists in our system. Do you want to configure the data ? "
              }
            />
          )}
          {openEditModal && editNodeId && (
            <EditModal
              isModalOpen={openEditModal}
              toggleYes={() => {
                onEditNode(editNodeId, editText);
                setOpenEditModal(false);
              }}
              toggleCancel={() => setOpenEditModal(false)}
              text={editText}
              handleTextChange={setEditText}
            />
          )}
          {openMessageModal && messageNodeId && (
            <MessageModal
              isModalOpen={openMessageModal}
              toggleCancel={() => {
                setOpenMessageModal(false);
                setMessageNodeId(null);
              }}
              onSave={(messages) => {
                onSetMessages(messageNodeId, messages);
                setOpenMessageModal(false);
                setMessageNodeId(null);
                showNotification("Success", "Messages saved successfully", "success");
              }}
              existingMessages={getNodeMessages(messageNodeId)}
              nodeTitle={getNodeTitle(messageNodeId)}
            />
          )}
          {copyEnabled && (
            <CopyModal
              isModalOpen={copyEnabled}
              setCopyEnabled={setCopyEnabled}
              setTreeDraft={setTreeDraft}
              props={props}
            />
          )}
          {deleteDraft && (
            <AdminConfirmationModal
              isModalOpen={deleteDraft}
              toggleYes={handleDeleteDraft}
              toggleCancel={() => setDeleteDraft(false)}
              bodyContent={"Are you sure you want to delete the draft?"}
            />
          )}
          {openPublishModal && (
            <AdminConfirmationModal
              isModalOpen={openPublishModal}
              toggleYes={handlePublishDraft}
              toggleCancel={() => setOpenPublishModal(false)}
              bodyContent={"Are you sure you want to publish the draft?"}
            />
          )}
          <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
          <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
            <div>
              <div className="row">
                <div className="col-12 col-xl-12">
                  <h3 className="mb-3 header-primary">AMI Chatbot Admin</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <Select
                    searchable
                    clearable={false}
                    options={countryOptions}
                    field={fields.country}
                    validate={(e) => validate(e, fields.country)}
                    onChange={() => {
                      setShowData(false);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    searchable
                    clearable={false}
                    options={userTypeOptions}
                    field={fields.userType}
                    validate={(e) => validate(e, fields.userType)}
                    onChange={() => {
                      setShowData(false);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    searchable
                    clearable={false}
                    options={languageOptions}
                    field={fields.language}
                    validate={(e) => validate(e, fields.language)}
                    onChange={() => {
                      setShowData(false);
                    }}
                  />
                </div>
                <div className=" col-md-2">
                  <button
                    className="btn btn-lg btn-info btn-rounded save_button"
                    style={{ marginTop: "10px" }}
                    onClick={handleSearchData}
                    disabled={
                      fields.country.value === "" ||
                      fields.userType.value === "" ||
                      fields.language.value === ""
                    }
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            {showData && (
              <div>
                <div
                  className="row"
                  style={{
                    marginTop: "15px",
                    marginLeft: "1px !important",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className={`col-4 col-xl-4 col-sm-6 amiLive ${
                      activeTab === "liveAMI" ? "activeTab" : ""
                    }`}
                    onClick={() => handleTabClick("liveAMI")}
                  >
                    AMI Live Data
                  </div>

                  <div
                    className={`col-4 col-xl-4 col-sm-6 amiLive ${
                      activeTab === "draftAMI" ? "activeTab" : ""
                    }`}
                    onClick={() => handleTabClick("draftAMI")}
                  >
                    AMI Draft Data
                  </div>
                </div>
                {activeTab === "liveAMI" ? (
                  <div className="tree-container">
                    <div className="row">
                      <div className="col-12 col-xl-12">
                        <h3 className="mb-3 header-primary">
                          Chat Data (Live)
                        </h3>
                      </div>
                    </div>
                    <div className="row">
                      {(treeLive || []).length > 0 ? (
                        <div style={{ width: "100%" }}>
                          <TreeNodeLive
                            node={treeLive[0]}
                            depth={0}
                            onToggle={onToggleLive}
                          />
                          <button
                            className="btn btn-lg btn-info btn-rounded save_button"
                            disabled={draftIsAvailable}
                            onClick={handleCreateDraft}
                          >
                            Create Draft
                          </button>
                        </div>
                      ) : (
                        <div>No Live Data Present</div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="tree-container">
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          alignItems: "center",
                        }}
                      >
                        <div className="col-12 col-xl-12" style={{ flex: 1 }}>
                          <h3 className="mb-3 header-primary">
                            Chat Data (Draft)
                          </h3>
                        </div>
                        {(treeDraft || []).length > 0 && (
                          <button
                            className="btn btn-primary btn-rounded"
                            style={{ alignSelf: "flex-start", marginTop: 0 }}
                            onClick={() => setCopyEnabled(true)}
                          >
                            Copy from
                          </button>
                        )}
                      </div>
                      <div className="row">
                        {(treeDraft || []).length !== 0 ? (
                          <div style={{ width: "100%" }}>
                            <TreeNodeDraft
                              node={treeDraft[0]}
                              depth={0}
                              treeData={treeDraft}
                              onToggle={onToggleDraft}
                              setOpenDeleteModal={setOpenDeleteModal}
                              setDeleteNodeId={setDeleteNodeId}
                              onAdd={addChildNode}
                              setOpenEditModal={setOpenEditModal}
                              setEditNodeId={setEditNodeId}
                              setEditText={setEditText}
                              setOpenMessageModal={setOpenMessageModal}
                              setMessageNodeId={setMessageNodeId}
                              isRootNode={true}
                              onMove={(draggedId, targetId, position = 'inside') => {
                                // deep clone treeDraft
                                const newTree = JSON.parse(JSON.stringify(treeDraft));
                                let draggedNode = null;

                                // remove dragged node from tree and keep reference
                                const removeNode = (nodes, id) => {
                                  for (let i = 0; i < nodes.length; i++) {
                                    if (nodes[i].id === id) {
                                      draggedNode = nodes.splice(i, 1)[0];
                                      return true;
                                    }
                                    if (nodes[i].children && nodes[i].children.length) {
                                      if (removeNode(nodes[i].children, id)) return true;
                                    }
                                  }
                                  return false;
                                };
                                removeNode(newTree, draggedId);
                                if (!draggedNode) return;

                                // find target node and perform insertion based on position
                                const insertRelative = (nodes, id, nodeToInsert, pos) => {
                                  for (let i = 0; i < nodes.length; i++) {
                                    const n = nodes[i];
                                    if (n.id === id) {
                                      if (pos === 'inside') {
                                        n.children = n.children || [];
                                        n.children.push(nodeToInsert);
                                        n.expanded = true;
                                      } else if (pos === 'before') {
                                        nodes.splice(i, 0, nodeToInsert);
                                      } else if (pos === 'after') {
                                        nodes.splice(i + 1, 0, nodeToInsert);
                                      }
                                      return true;
                                    }
                                    if (n.children && n.children.length) {
                                      if (insertRelative(n.children, id, nodeToInsert, pos)) return true;
                                    }
                                  }
                                  return false;
                                };

                                // if targetId refers to the root element (treeDraft[0]) and position is before/after,
                                // handle insertion at root level as well
                                const rootId = newTree && newTree[0] && newTree[0].id;
                                if ((position === 'before' || position === 'after') && rootId === targetId) {
                                  const idx = 0; // target is root
                                  if (position === 'before') newTree.splice(idx, 0, draggedNode);
                                  else newTree.splice(idx + 1, 0, draggedNode);
                                } else {
                                  // normal insertion
                                  insertRelative(newTree, targetId, draggedNode, position);
                                }

                                setTreeDraft(newTree);
                              }}
                            />
                            <button
                              className="btn btn-lg btn-info btn-rounded save_button"
                              style={{ backgroundColor: "#071d49" }}
                              onClick={() => setOpenPublishModal(true)}
                              disabled={
                                treeDraft.length === 1 &&
                                treeDraft[0].id === "project-1" &&
                                treeDraft[0].htmlContent ===
                                  "<p>New Node</p><p>Click edit to add content...</p>" &&
                                treeDraft[0].children.length === 0 &&
                                treeDraft[0].expanded === false
                              }
                            >
                              Publish
                            </button>
                            <button
                              className="btn btn-lg btn-rounded btn-success"
                              style={{ marginRight: "16px" }}
                              onClick={handleSave}
                            >
                              Save
                            </button>
                            <button
                              className="btn btn-lg btn-rounded btn-danger"
                              onClick={() => setDeleteDraft(true)}
                            >
                              Delete
                            </button>
                          </div>
                        ) : (
                          <div>No Draft Data Present</div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* {openDeleteModal && (
        <DeleteModal onCloseModal={() => setOpenDeleteModal(false)} onDelete={()=>confirmDelete(deleteNodeId)}/>
      )} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});

export default connect(mapStateToProps, { notify })(ami);


// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AMI/ami.js